const FormResources = {

    form_data:{
        building_id:        [],
        level_id:           [],
        area_id:            [],
        description:        '',
        custom_description: '',
        second_description: '',
        task_id:            '',
        room_type_id:       '',
        floor_id:           '',
        cost_center_id:     '',
        closed:               '',
        door_number:        '',

        fixture_simbol:     1,
        fixtures:           '',

        sq_ft_simbol:       1,
        sq_ft:              '',

        essential_cleaning: '',
        work_group:         '',
        exclude_daily:      '',
        exclude_project:    '',
        patient:            '',

        freq_simbol:        1,
        frequency:          '',

        notes:              '',
        disabled_daily:     '',
        disabled_project:   '',

        radio:              '',


        time_adjustment_simbol:       1,
        time_adjustment:              '',

        shift1:             false,
        shift2:             false,
        shift3:             false,
        none:               false,
        show_rooms_that_are: 'none_room_state',
        show_properly_assigned_rooms: true,
        daily_assignment_id: [],
        module_name: ''
    },

    radio_options: [
        {
            div_class: 'form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'daily',
            name: 'Daily',
            model: 'daily',
        },
        {
            div_class: 'form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'projects',
            name: 'Project',
            model: 'projects',
        },
        {
            div_class: 'form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'policing',
            name: 'Policing',
            model: 'policing',
        },
    ],

    radio_room_state_options: [
        {
            div_class: 'col-auto px-3 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'unassigned',
            name: 'Unassigned',
            model: 'unassigned',
        },
        {
            div_class: 'col-auto px-3  form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'underassigned',
            name: 'Underassigned',
            model: 'underassigned',
        },
        {
            div_class: 'col-auto px-3  form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'overassigned',
            name: 'Overassigned',
            model: 'overassigned',
        },
        {
            div_class: 'col-auto px-3 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'none_room_state',
            name: 'None',
            model: 'none_room_state',
        },
    ],

    form_format:
    [
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select building(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select level(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select area(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select daily assignment(s)',
            close_on_option: false,
            track_by: 'name'
        },
    ]

}

export default FormResources